












import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import TimesheetDto from '@/models/Timesheets/TimesheetDto';
import JourneyType from '@/models/Timesheets/JourneyType';

@Component({
  name: 'JourneyDetails',
})
export default class extends GiganautVue {

	@Prop({required: true})
	timesheet: TimesheetDto;

	get journeyType() {
		if (this.timesheet.journeyType === JourneyType.PassengerToLocation) {
			return "Passenger To Location";
		}
		if (this.timesheet.journeyType === JourneyType.PassengerFromLocation) {
			return "Passenger From Location";
		}
		if (this.timesheet.journeyType === JourneyType.PassengerRoundTrip) {
			return "Passenger Round Trip";
		}
		if (this.timesheet.journeyType === JourneyType.DriverToLocation) {
			return "Driver To Location";
		}
		if (this.timesheet.journeyType === JourneyType.DriverFromLocation) {
			return "Driver From Location";
		}
		if (this.timesheet.journeyType === JourneyType.DriverRoundTrip) {
			return "Driver Round Trip";
		}
		return "Own Way There"
	}
	get isJourneyTracked() {
		return this.timesheet.isJourneyTrackingEnabled;
	}

	get isPassenger() {
		if (this.timesheet.journeyType === JourneyType.PassengerToLocation) {
			return true;
		}
		if (this.timesheet.journeyType === JourneyType.PassengerFromLocation) {
			return true;
		}
		if (this.timesheet.journeyType === JourneyType.PassengerRoundTrip) {
			return true;
		}
		return false;
	}

	get isDriver() {
		if (this.timesheet.journeyType === JourneyType.DriverToLocation) {
			return true;
		}
		if (this.timesheet.journeyType === JourneyType.DriverFromLocation) {
			return true;
		}
		if (this.timesheet.journeyType === JourneyType.DriverRoundTrip) {
			return true;
		}
		return false;
	}

	get isOwnWayThere() {
		return this.timesheet.journeyType === JourneyType.OwnWayThere;
	}

	get isToLocation() {
		if (this.timesheet.journeyType === JourneyType.DriverToLocation) {
			return true;
		}
		if (this.timesheet.journeyType === JourneyType.PassengerToLocation) {
			return true;
		}
		return false;
	}

	get isFromLocation() {
		if (this.timesheet.journeyType === JourneyType.DriverFromLocation) {
			return true;
		}
		if (this.timesheet.journeyType === JourneyType.PassengerFromLocation) {
			return true;
		}
		return false;
	}

	get isRoundTrip() {
		if (this.timesheet.journeyType === JourneyType.DriverRoundTrip) {
			return true;
		}
		if (this.timesheet.journeyType === JourneyType.PassengerRoundTrip) {
			return true;
		}
		if (this.timesheet.journeyType === JourneyType.OwnWayThere) {
			return true;
		}
		return false;
	}

}
